import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile({
  breakpoint = MOBILE_BREAKPOINT,
  useHeight = false,
}: {
  breakpoint?: number;
  useHeight?: boolean;
}) {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined
  );

  React.useEffect(() => {
    const mql = useHeight
      ? window.matchMedia(`(max-height: ${breakpoint - 1}px)`)
      : window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = () => {
      if (useHeight) {
        setIsMobile(window.innerHeight < breakpoint);
      } else {
        setIsMobile(window.innerWidth < breakpoint);
      }
    };
    mql.addEventListener("change", onChange);
    if (useHeight) {
      setIsMobile(window.innerHeight < breakpoint);
    } else {
      setIsMobile(window.innerWidth < breakpoint);
    }
    return () => mql.removeEventListener("change", onChange);
  }, [breakpoint, useHeight]);

  return !!isMobile;
}

const MOBILE_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

const subscribeToMobileQuery = (onChange: () => void) => {
  const mql = window.matchMedia(MOBILE_QUERY);
  mql.addEventListener("change", onChange);
  return () => mql.removeEventListener("change", onChange);
};

/** Unlike `useIsMobile`, correct on the first client render, so a component mounted after hydration does not paint the desktop layout first. */
export const useIsMobileViewport = (): boolean =>
  React.useSyncExternalStore(
    subscribeToMobileQuery,
    () => window.matchMedia(MOBILE_QUERY).matches,
    () => false
  );
